import { ISelector } from '../interfaces/ISelector';
import { validateNamespace } from '../validateNamespace/validateNamespace';

export interface ISelectorFactory<TState> {
    (selector: ISelector<TState, any>): ISelector<TState, any>;
}

export function createNamespaceSelectorFactory<TState> (namespace: string): ISelectorFactory<TState> {
    validateNamespace(namespace);

    return (selector: ISelector<TState, any>) => {
        return (state: TState, ...args: any[]): any => {
            return selector((state as any)[namespace], ...args);
        };
    };
}